import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { readSaved } from '../gameDeck';
export default function CreativeGate({ children, needsRound = false }) {
  const { urlGameCode: code } = useParams();
  const { pathname } = useLocation();
  const session = readSaved(code + '_data', null);
  if (!session?.playerId) return <Navigate to={`/creative-mode/${code}/enter-prompts`} replace />;
  if (!session.isHost) return <Navigate to={`/creative-mode/${code}/close-phone`} replace />;
  if (needsRound && !session.orderOfPrompts?.length) return <Navigate to={`/creative-mode/${code}/waiting-lobby`} replace />;
  if (session.completed && pathname.endsWith('/play')) return <Navigate to={`/creative-mode/${code}/results`} replace />;
  return children;
}
